export function cartProducts(cartData) {
  return {
    type: 'CART_DATA',
    cartData
  }
}